import { MessageOption } from "@/types/conversationTypes";

interface Props {
  option: MessageOption;
}

const TourOption = ({ option }: Props) => {
  const details = option.tourDetails;
  const { title, description, duration, price, rating, reviewCount, url, image } = details;

  return (
    <div className="p-4 border border-brand-100 rounded-xl bg-white shadow-sm text-xs flex gap-4">
      {image && (
        <img
          src={image}
          alt={title || 'Tour image'}
          className="w-20 h-20 rounded object-cover border border-gray-200"
          loading="lazy"
          onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }}
        />
      )}
      <div className="flex-1 flex flex-col gap-1 min-w-0">
        {title && (
          <h3 className="text-sm font-semibold text-gray-900 leading-tight truncate" title={title}>{title}</h3>
        )}
        <div className="flex items-center gap-2 flex-wrap">
          {price && (
            <p className="text-[11px] text-brand-600 font-medium">{price}</p>
          )}
          {rating != null && (
            <p className="text-[11px] text-yellow-600 font-medium">★ {rating.toFixed(1)}{reviewCount ? ` (${reviewCount})` : ''}</p>
          )}
          {duration != null && (
            <p className="text-[11px] text-gray-500">{duration} min</p>
          )}
        </div>
        {description && (
          <p className="text-[11px] text-gray-700 line-clamp-3" title={description}>{description}</p>
        )}
        {url && (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-1 inline-flex items-center text-[11px] text-brand-600 hover:text-brand-700 font-medium underline decoration-brand-300 decoration-[1.5px] underline-offset-[3px]"
          >
            Check on Viator
          </a>
        )}
      </div>
    </div>
  );
};

export default TourOption;
